import $ from "jquery";
import "moment-timezone";
import moment from "moment";
import React, { useState, useEffect, useContext, forwardRef } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import DateUtil from "../../util/DateUtil";
import DropdownButton from "../bootstrap4/DropdownButton";
import Loading from "../Loading";
import { Context } from '../../views/app';

function WorkHours(props, refs) {

  let user = useContext(Context).user;
  let siteComponentRef = props.site_component;
  let workDaysDropDown = [
    { value: "0", label: "No weekends", type: "work_days" },
    { value: "6", label: "Saturday", type: "work_days" },
    { value: "7", label: "Sunday", type: "work_days" },
    { value: "6 7", label: "Both", type: "work_days" },
  ];

  let site_config = { ...DateUtil.getConfiguredWorkHours(user.site_selected) };
  let startTime = new Date();
  startTime.setHours(parseInt(site_config.work_hours.work_hours_start.replace(":00", "")));
  startTime.setMinutes(0);
  let endTime = new Date();

  if (site_config.work_hours.work_hours_end === "23:59")
    site_config.work_hours.work_hours_end = "00:00";

  endTime.setHours(
    parseInt(site_config.work_hours.work_hours_end.replace(":00", ""))
  );
  endTime.setMinutes(0);
  
  const [siteconfig, setSiteConfig] = useState({ ...site_config });
  const [start_Time, setStartTime] = useState(startTime);
  const [end_Time, setEndTime] = useState(endTime);
  let loading = '';
  let timeZoneTime = [];

  const time = { startTime, endTime, site_config };
  const workHoursState = JSON.stringify(time);

  let timezone = user.site_selected.site_iana_timezone ? user.site_selected.site_iana_timezone : moment.tz.guess();
  let siteTimeRef = {};

  useEffect(() => {
    $(".datepicker").attr("readonly", "true");
    setInterval(
      function () {
        let timeNow = {
          curTime: moment.tz(new Date().getTime(), moment.tz.guess()).format("YYYY-MM-DD HH:mm:ss z"),
          siteTime: moment.tz(new Date().getTime(), timezone).format("YYYY-MM-DD HH:mm:ss z")
        };
        if (siteTimeRef)
          siteTimeRef.innerText = timeNow.siteTime;
      }.bind(),
      1000
    );
    // isChanged();
  }, [siteTimeRef]);

  const isChanged = () => {
    let isModified = false;
    if (siteconfig.work_hours) {
      siteComponentRef.user.site_selected.site_config.work_hours.work_hours_end = siteconfig.work_hours.work_hours_end;
      siteComponentRef.user.site_selected.site_config.work_hours.work_hours_start = siteconfig.work_hours.work_hours_start;
      siteComponentRef.user.site_selected.site_config.work_hours.include_weekends = siteconfig.work_hours.include_weekends;

      siteComponentRef.isWorkHoursObjectModified();
      return isModified;
    }
  };

  const handleSelectOnChange = obj => {
    let workhours = { ...siteconfig };
    workhours.work_hours.include_weekends = obj.value;
    setSiteConfig(workhours);
  };

  const resetChanges = () => {
    let workHrsState = JSON.parse(workHoursState);
    workHrsState.startTime = new Date(workHrsState.startTime);
    workHrsState.endTime = new Date(workHrsState.endTime);
    setStartTime(workHrsState.startTime);
    setEndTime(workHrsState.endTime);
    setSiteConfig(workHrsState.site_config);
  };

  useEffect(() => {
    let workHrsState = JSON.parse(workHoursState);
    if (workHrsState.site_config !== siteconfig) {
      isChanged();
    }
  }, [siteconfig]);


  React.useImperativeHandle(refs, () => ({
    resetChanges
  }));
  return (
    <React.Fragment>
      {loading && (<div> <Loading> Saving Work Hours Information ...</Loading> </div>)}

      {!loading && (
        <React.Fragment>
          <div className='row'>
            <div className='col-md-4 col-4'>
              <label>Site Time : </label>
            </div>
            <div className='col-md-8 col-8' ref={x => (siteTimeRef = x)}>
              {timeZoneTime}
            </div>
          </div>
          {props.extended_enabled === false && <React.Fragment>
            <div className='row mt-1'>
              <div className='offset-md-4 col-md-8 offset-4 col-8'>
                <small className='mr-5'>Start Time</small>
                <small>End Time</small>
              </div>
            </div>
            <div className='row mt-1'>
              <div className='col-md-4 col-4'>
                <label>Work Hours : </label>
              </div>
              <div className='col-md-8 col-8 d-flex ml-0'>
                <DatePicker
                  id="startDate"
                  className='datepicker form-control w-75 d-inline mr-1'
                  showTimeSelect
                  showTimeSelectOnly
                  timeIntervals={60}
                  timeCaption='Time'
                  dateFormat='h aa'
                  selected={start_Time}
                  selectsStart
                  disabled={props.extended_enabled}
                  onChange={startTime => {
                    let work_hours_start = ("0" + startTime.getHours()).slice(-2) + ":00";
                    let work_hours_end = end_Time.getHours() + ":00";
                    let endTime = DateUtil.addHours(startTime, 10);
                    if (endTime.getDate() !== startTime.getDate()) {
                      endTime.setHours(0);
                    }
                    work_hours_end = ("0" + endTime.getHours()).slice(-2) === "00" ? "23:59" : endTime.getHours() + ":00";
                    startTime.setMinutes(0);
                    endTime.setMinutes(0);
                    let workhours = { ...siteconfig };
                    workhours.work_hours.work_hours_start = work_hours_start;
                    workhours.work_hours.work_hours_end = work_hours_end
                    setStartTime(startTime);
                    setEndTime(endTime);
                    setSiteConfig(workhours);
                    $(".datepicker").attr("readonly", "true");
                  }}
                />

                <DatePicker
                  id="endDate"
                  className='datepicker form-control w-75 '
                  showTimeSelect
                  showTimeSelectOnly
                  timeIntervals={60}
                  timeCaption='Time'
                  dateFormat='h aa'
                  selected={end_Time}
                  disabled={props.extended_enabled}
                  timeClassName={() => { }}
                  selectsEnd
                  minTime={moment().startOf("day").toDate()}
                  maxTime={moment().endOf("day").toDate()}
                  onFocus={e => {
                    setTimeout(() => {
                      var disableTill = moment(start_Time).format("h:00 A");
                      //console.log('disableTill : ' + disableTill);
                      var els = $(".react-datepicker__time-list-item");
                      var el = els[0];
                      if (el && el.innerText === "12:00 AM") {
                        var parent = $(el).parent();
                        $(el).appendTo(parent);
                      }
                      for (let i = 1; i < els.length; i++) {
                        let el1 = els[i];
                        $(el1).addClass("react-datepicker__time-list-item--disabled");
                        $(el1).off().on("click", () => { return false; });
                        if (el1.innerText === disableTill) {
                          break;
                        }
                      }
                    }, 100);
                  }}
                  onChange={endTime => {
                    endTime.setMinutes(0);
                    let site_config = { work_hours: { ...siteconfig.work_hours, work_hours_end: ("0" + endTime.getHours()).slice(-2) === "00" ? "23:59" : ("0" + endTime.getHours()).slice(-2) + ":00" }, };
                    setEndTime(endTime);
                    setSiteConfig(site_config);
                    $(".datepicker").attr("readonly", "true");
                  }}
                />
              </div>
            </div>
            {/* {console.log('ss', siteconfig)} */}
            <div className='row mt-3'>
              <div className='col-md-4 col-4'>
                <label>Include Weekends : </label>
              </div>
              <div className='col-md-8 col-8'>
                <DropdownButton
                  className={props.extended_enabled ? 'btn btn-sm d-inline dropdown-toggle text-dark disabled inactive ' : 'btn btn-sm d-inline dropdown-toggle text-dark'}
                  onOptionClick={handleSelectOnChange}
                  default={" -- Choose -- "}
                  selected={siteconfig.work_hours.include_weekends}
                  opts={workDaysDropDown}
                  field_attr='value'
                  value_attr='label'
                />
              </div>
            </div>
          </React.Fragment>}
        </React.Fragment>
      )}
    </React.Fragment>
  );

}

export default forwardRef(WorkHours);